import { getMatchedJobsThunk } from '../../../../../store/workspace/thunks';
import CodingExamCard from '../../../../../components/CodingExamCard';
import { useDispatch, useSelector } from '../../../../../store/store';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import InterviewCard from '../../../../../components/InteviewCard';
import { selectUserId } from '../../../../../store/auth/selectors';
import { JobBoxTab } from '../../../../../store/workspace/types';
import Loading from '../../../../../components/Loading';
import JobCard from '../../../../../components/JobCard';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
  selectMatchedJobs,
  selectExamsHistory,
  selectLoadingMatchedJobs,
} from '../../../../../store/workspace/selectors';
import DropDown from '../../../../../components/DropDown';

interface TabItem {
  id: JobBoxTab;
  title: string;
}

const tabList: TabItem[] = [
  {
    id: 'RecruitingInterview',
    title: 'Recruiting interview',
  },
  {
    id: 'MultipleChoice',
    title: 'Multiple choice exam',
  },
  {
    id: 'Coding',
    title: 'Coding exam',
  },
  {
    id: 'Interview',
    title: 'Interview',
  },
];

function JobList() {
  const jobs = useSelector(selectMatchedJobs);
  const history = useSelector(selectExamsHistory);
  const loading = useSelector(selectLoadingMatchedJobs);
  const codingExams = jobs.filter(i => i.status === 'codingExam');
  const interviewList = history.filter(i => i.status === 'interview');
  const multipleChoiceExam = jobs.filter(i => i.status === 'multipleChoiceExam');
  const [selectedTab, setSelectedTab] = useState<JobBoxTab>('RecruitingInterview');
  const recruitingInterview = jobs.filter(i => i.status === 'recruitingInterview');

  const userId = useSelector(selectUserId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return;
    dispatch(getMatchedJobsThunk(userId));
  }, [userId]);

  return (
    <MotionWrapper className={styles.container}>
      <span className={styles.title}>
        Potential jobs based on your profile
      </span>

      <div className={styles.tab}>
        <div
          className={styles.tab_item}
          onClick={() => setSelectedTab('RecruitingInterview')}
          data-is-active={selectedTab === 'RecruitingInterview'}
        >
          <span>Recruiting interview</span>
        </div>
        <div
          className={styles.tab_item}
          onClick={() => setSelectedTab('MultipleChoice')}
          data-is-active={selectedTab === 'MultipleChoice'}
        >
          <span>Multiple choice exam</span>
        </div>
        <div
          className={styles.tab_item}
          onClick={() => setSelectedTab('Coding')}
          data-is-active={selectedTab === 'Coding'}
        >
          <span>Coding exam</span>
        </div>
        <div
          className={styles.tab_item}
          onClick={() => setSelectedTab('Interview')}
          data-is-active={selectedTab === 'Interview'}
        >
          <span>Interview</span>
        </div>
      </div>

      <DropDown
        idKey='id'
        titleKey='title'
        dropDownList={tabList}
        containerClassName={styles.tab_dropdown}
        setItem={(item: TabItem) => setSelectedTab(item.id)}
        selectedItem={tabList.find(item => item.id === selectedTab)}
      />

      <div className={styles.job_list}>
        {loading && <Loading />}
        {!loading && selectedTab === 'RecruitingInterview' &&
          (recruitingInterview.length > 0 ? recruitingInterview.map(job => <JobCard tab='recruitingInterview' CtaTitle='Start recruiting interview' jobDetail={job} />) :
            <span className={styles.job_list_empty_state}>
              There are no matched recruiting interview available for you.<br />
              Please come back later.
            </span>)}
        {!loading && selectedTab === 'MultipleChoice' && (multipleChoiceExam.length > 0 ? multipleChoiceExam.map(job => <JobCard tab='multipleChoiceExam' jobDetail={job} />) :
          <span className={styles.job_list_empty_state}>
            There are no matched multiple-choice exams available for you.<br />
            Please come back later.
          </span>)}
        {!loading && selectedTab === 'Coding' && (codingExams.length > 0 ? codingExams.map(job => <CodingExamCard jobDetail={job} />) :
          <span className={styles.job_list_empty_state}>
            There are no coding exams available for you.<br />
            Please come back later.
          </span>
        )}
        {!loading && selectedTab === 'Interview' && (interviewList.length > 0 ? interviewList.map(job => <InterviewCard jobDetail={job} />) :
          <span className={styles.job_list_empty_state}>
            There are no interviews available for you.<br />
            Please come back later
          </span>)}
      </div>
    </MotionWrapper>
  )
};

export default JobList;
